import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Big from "big.js";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import {
  Page,
  Loadable,
  DataTable,
  ViewSaleButton,
  Fab,
  If,
  SaleStatusSemaphore,
  CurrencyValue,
  InfoTooltip
} from "components/support";

import { SaleStatus } from "core/enum";

import styles from "./styles";
import SalesReportFilter from "./filter";
import SummaryCard from "./summary-card";

import { colors, Icon } from "assets";
import { fn } from "util";

export default class SalesReportView extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        accessor: "activated_at",
        type: "datetime",
        align: "center",
        Header: "Data"
      },
      {
        accessor: "number",
        id: "document_number",
        Header: "Documento",
        Cell: props => (
          <ViewSaleButton
            sale={{
              uuid: props.row._original.sale_uuid,
              document: {
                type: props.row._original.type,
                serie: props.row._original.serie,
                number: props.row._original.number
              }
            }}
          />
        )
      },
      {
        accessor: "status",
        Header: "Status",
        type: "enum",
        align: "center",
        params: { enum: SaleStatus },
        Cell: props => (
          <SaleStatusSemaphore
            status={props.row._original.status}
            description={props.row._original.sefaz_description}
            code={props.row._original.sefaz_code}
            type={props.row._original.type}
          />
        )
      },
      {
        id: "revenues_value",
        type: "money",
        accessor: report => report.revenues_value,
        Header: "Faturamento",
        align: "right"
      },
      {
        id: "costs_value",
        type: "money",
        accessor: report => report.costs_value,
        Header: (
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Custos
            <InfoTooltip hint="Não são considerados os custos dos opcionais." />
          </span>
        ),
        align: "right"
      },
      {
        id: "profit",
        accessor: report => fn.centsToReal(report.profit),
        Header: "Lucro Bruto",
        align: "right",
        Cell: props => this.saleProfit(props.original)
      }
    ]
  };

  saleProfit({ profit, revenues_value }) {
    const profitInPercentage =
      revenues_value !== 0 ? profit / revenues_value : 0;
    return (
      <div>
        <CurrencyValue value={profit} type="money" />
        {
          <span style={styles.profitChip}>
            {profit >= 0
              ? Big(profitInPercentage)
                  .times(100)
                  .toFixed(2)
              : `0.00`}
            %
          </span>
        }
      </div>
    );
  }

  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const { loading, filters, pagination, order, results, summary } = viewModel;
    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Relatório de Vendas
        </Typography>

        <SalesReportFilter
          loading={loading}
          filters={filters}
          onChange={filters => presenter.onFilterChange(filters)}
          onFilter={filters => presenter.onFilterChange(filters)}
        />
        <If
          test={
            (filters.documentNumber === "" || filters.documentSerie === "") &&
            ["all", "active"].includes(filters.saleStatus)
          }
        >
          <Row>
            <Col xs={12} md>
              <SummaryCard
                loading={loading}
                value={summary.total_revenues}
                label="Faturamento Total"
                tooltip="Inclui faturamento dos opcionais."
              />
            </Col>
            <Col xs={12} md>
              <SummaryCard
                loading={loading}
                value={summary.total_costs}
                label="Custos"
                tooltip="Não são considerados os custos dos opcionais."
              />
            </Col>
            <Col xs={12} md>
              <SummaryCard
                loading={loading}
                revenues={summary.total_revenues}
                value={summary.profit}
                label="Lucro"
              />
            </Col>
          </Row>
        </If>
        <Loadable loading={loading}>
          <Paper elevation={1}>
            <DataTable
              manual
              filterable={false}
              defaultSorted={[
                {
                  id: order.field,
                  desc: order.direction === "DESC"
                }
              ]}
              config={this.config}
              resultSet={results}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.page}
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={page => presenter.onPageChange(page + 1)}
              onChange={({ field, value }) =>
                presenter.onOrderChange(field, value)
              }
            />
          </Paper>
        </Loadable>

        {this.downloadButton()}
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/management/sales-report/view.jsx